import { z } from 'zod';

/** URL search for payroll-core mock target selection (Dexie-backed). */
export const payrollPersonTargetsSearchSchema = z.object({
  page: z.coerce.number().optional().default(1),
  pageSize: z.coerce.number().optional().default(100),
  freeText: z.string().optional(),
  departmentIn: z.array(z.string()).optional()
});
export type PayrollPersonTargetsSearch = z.infer<typeof payrollPersonTargetsSearchSchema>;